import api from '@/features/api/axios';
import { logger } from '@/features/help/utils/logger';

// Purpose: Fetch company name by a public user shortId (public endpoint)
export async function getCompanyNameByShortId(shortId: string): Promise<string> {
  try {
    const { data } = await api.get<{ company_name: string }>(
      `/api/auth/company-name-by-shortid/${shortId}`
    );
    return data.company_name || '';
  } catch (error) {
    logger.error('CompanyAPI', 'Failed to fetch company name by shortId', { error, shortId });
    throw error as Error;
  }
}


